import { useTranslation } from '@frontend/i18n';
import { ContentSwitcher, DropdownFilterChipField, styles, useFormField } from '@frontend/design-system';
import { ROUTING_ANALYTICS_ID } from '../routing-analytics-panel';
import type { ChartView, EntityType } from './types';

type GroupHeaderActionProps = {
  onChangeView: (val: ChartView) => void;
  onChangeFilter: (val: string[]) => void;
  customNameHeaders: Record<
    string,
    {
      name: string;
      devicesCount: number;
    }
  >;
  entityType?: EntityType;
};

export const GroupHeaderAction = ({
  onChangeView,
  onChangeFilter,
  customNameHeaders,
  entityType,
}: GroupHeaderActionProps) => {
  const { t } = useTranslation('analytics-phone');
  const ids = Object.keys(customNameHeaders ?? []);
  const checkListField = useFormField(
    {
      type: 'checklist',
      value: ids,
    },
    []
  );
  const lowerCaseEntityType = entityType?.toLowerCase();

  return (
    <>
      <ContentSwitcher<ChartView> defaultValue='dashboard' onValueChange={onChangeView}>
        <ContentSwitcher.Option
          value='dashboard'
          label={t('Dashboard')}
          trackingId={`${ROUTING_ANALYTICS_ID}-'call${lowerCaseEntityType}-dashboardview`}
        />
        <ContentSwitcher.Option
          value='table'
          label={t('Table')}
          trackingId={`${ROUTING_ANALYTICS_ID}-'call${lowerCaseEntityType}-tableview`}
        />
      </ContentSwitcher>
      <DropdownFilterChipField
        {...checkListField}
        onChange={(e) => {
          checkListField.onChange(e);
          // @ts-ignore - event types are not correct
          onChangeFilter(e.value);
        }}
        label={t('Call {{ entityType }}', { entityType })}
        icon={entityType === 'Group' ? 'call-group' : 'call-queue'}
        name='analytics-phone-group-panel-dropdown'
        showClearAll={false}
        onApply={({ close }) => {
          close();
        }}
        trackingIdBase={`${ROUTING_ANALYTICS_ID}-'call${lowerCaseEntityType}-filter`}
      >
        {Object.entries(customNameHeaders ?? []).map(([key, option]) => (
          <DropdownFilterChipField.Option key={key} value={key} css={{ label: styles.truncate }}>
            {option.name}
          </DropdownFilterChipField.Option>
        ))}
      </DropdownFilterChipField>
    </>
  );
};
